import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import { useEditItemsContext } from './context';
import messages from './messages';

const InvalidQuantity = 'InvalidQuantity';
const MissingNameField = 'MissingField';
const InvalidAttemptToEditMarketplaceOrder = 'InvalidAttemptToEditMarketplaceOrder';
const InvalidAttemptToEditFulfillmentPlan = 'InvalidAttemptToEditFulfillmentPlan';
const InvalidAttemptToEditSplitItem = 'InvalidAttemptToEditSplitItem';

const ErrorCodesToMessageMap = {
  [InvalidQuantity]: <FormattedMessage {...messages.invalidQuantityErrorMessage} />,
  [MissingNameField]: <FormattedMessage {...messages.missingNameFieldErrorMessage} />,
  [InvalidAttemptToEditMarketplaceOrder]: <FormattedMessage {...messages.invalidAttemptToEditMarketplaceOrderErrorMessage} />,
  [InvalidAttemptToEditFulfillmentPlan]: <FormattedMessage {...messages.invalidAttemptToEditFulfillmentPlanErrorMessage} />,
  [InvalidAttemptToEditSplitItem]: <FormattedMessage {...messages.invalidAttemptToEditSplitItemErrorMessage} />,
};

const DefaultErrorMessage = <FormattedMessage {...messages.defaultSaveErrorMessage} />;

const getErrorMessage = (errors = []) => {
  const firstMappedError = errors.find((error) => ErrorCodesToMessageMap[error?.ErrorContext] || ErrorCodesToMessageMap[error?.Code]);
  const mappedErrorMessage = ErrorCodesToMessageMap[firstMappedError?.ErrorContext] || ErrorCodesToMessageMap[firstMappedError?.Code];
  return mappedErrorMessage || DefaultErrorMessage;
};

const ErrorBanner = () => {
  const { errors } = useEditItemsContext();

  if (!errors.length) {
    return null;
  }

  return <BannerMessageV2 content={getErrorMessage(errors)} status={BannerStatus.Error} />;
};

export default ErrorBanner;
